import React from 'react';
import './VideoTaskModalContent.css'; // You can move styles here or reuse Modal.css

export default function SuccessModalContent() {
  return (
    <>
      <div className="modal-image">
        <img src={require("./assets/reel-icon-2.png")} alt="Film reel" />
      </div>
      <h1 className='modal-title-text'>Thank You!</h1>
      <div className="modal-text">
        <p>
          Thank you for submitting your video! Our team will review it shortly to make sure it meets the guidelines. Once approved, your reward will be on the way.
        </p>
      </div>

      {/* <div className="modal-input-row">
        <input type="text" placeholder="Submit Link" />
        <button className="arrow-btn">→</button>
      </div> */}

      <button
        onClick={() => {
          window.location.href = "https://giveaway.givvy.net"
        }}
        className="submit-btn"
      >
        EARN MORE
      </button>
    </>
  );
}
